import React, {
  memo, useCallback,
} from 'react';
import { Box, Typography } from '@mui/material';
import { longDateFormatter } from 'utils/formatDateTime';
import Tooltip from '@mui/material/Tooltip';
import { COMPETITION_COMPLETED_STATUS, competitionStatus } from 'constants/competitions';
import useInvalidateCompetition from 'hooks/useInvalidateCompetition';
import CompetitionCountdownTimer from 'components/pages/Competition/CompetitionCountdownTimer';
import CompetitionHeaderStyles from 'components/pages/Competition/CompetitionHeader/competitionHeader.styles';
import JoinButton from 'components/pages/Competition/JoinButton';

const CompetitionHeader = memo(({ competition, competitionId }) => {
  const invalidateCompetition = useInvalidateCompetition(competitionId);

  const start = competition?.start;
  const end = competition?.end;
  const status = competition?.status;

  const handleCountdownEnd = useCallback(() => {
    invalidateCompetition();
  }, [invalidateCompetition]);

  return (
    <Box display="flex" alignItems="flex-start" sx={CompetitionHeaderStyles.layout(competition.thumbnail)}>
      {/* <Box sx={CompetitionHeaderStyles.thumbnailContainer}> */}
      {/*  <CompetitionThumbnail thumbnail={competition.thumbnail} name={competition.name} /> */}
      {/* </Box> */}
      <Box sx={CompetitionHeaderStyles.thumbnailOverlay} />

      <Box sx={CompetitionHeaderStyles.content}>
        <Box sx={CompetitionHeaderStyles.descriptionStatusContainer}>
          <Typography variant="h6" sx={CompetitionHeaderStyles.title}>
            {competition.name || 'Hackathon Title'}
          </Typography>
        </Box>
        <Box sx={CompetitionHeaderStyles.descriptionStatusContainer}>
          <Typography variant="body2" sx={CompetitionHeaderStyles.description}>
            {competition.description || 'No description available'}
          </Typography>
          <Box sx={{
            display: 'flex', alignItems: 'center', flexWrap: 'wrap', minWidth: 'fit-content',
          }}
          >
            <Box sx={CompetitionHeaderStyles.statusContainer}>
              <Tooltip title={`Deadline: ${longDateFormatter(end)}`} placement="bottom-start" arrow>
                <Typography sx={{ paddingRight: '8px', fontSize: '16px', lineHeight: '16px' }}>
                  <Typography
                    sx={CompetitionHeaderStyles.status(competition.status, 'dot')}
                    component="span"
                  />
                  {competitionStatus[status] ?? 'Unknown Status'}
                </Typography>
              </Tooltip>
              {status !== COMPETITION_COMPLETED_STATUS ? (
                <CompetitionCountdownTimer
                  start={start}
                  end={end}
                  status={status}
                  onCountdownEnd={handleCountdownEnd}
                />
              ) : null}
            </Box>
            <JoinButton
              styles={CompetitionHeaderStyles.actionButton}
              id={competition.competitionId}
              competition={competition}
            />
          </Box>

        </Box>
      </Box>
    </Box>
  );
});

export default CompetitionHeader;
